module.exports = __webpack_public_path__ + "img/P150T_weapon_97.0ba057f1.png";